import Outlined from './Outlined'

export default Outlined
